import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { motion, AnimatePresence } from "framer-motion";

export default function Contact() {
    const form = useRef();

    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);

    const sendEmail = async (e) => {
    e.preventDefault();

    setSending(true);

    try {

        // EMAIL TO YOU
        await emailjs.sendForm(
            "service_4xagpq5",
            "template_em3m2c9",
            form.current,
            "QLnHvCeYsB1vCYKSt"
        );

        // AUTO REPLY TO USER
        await emailjs.sendForm(
            "service_4xagpq5",
            "template_yp0pjzp",
            form.current,
            "QLnHvCeYsB1vCYKSt"
        );

        setSending(false);
        setSuccess(true);

        form.current.reset();

        setTimeout(() => {
            setSuccess(false);
        }, 5000);

    } catch (error) {
        console.log(error);
        setSending(false);
    }
};

    return (
        <section
            id="contact"
            className="relative py-32 bg-[#0b0b0f] text-white overflow-hidden"
        >

            {/* BACKGROUND GLOWS */}
            <div className="absolute inset-0 pointer-events-none">

                <div className="
          absolute top-0 left-1/4
          w-[500px] h-[500px]
          bg-cyan-500/10
          blur-[160px]
          rounded-full
        " />

                <div className="
          absolute bottom-0 right-1/4
          w-[450px] h-[450px]
          bg-purple-500/10
          blur-[160px]
          rounded-full
        " />
            </div>

            <div className="max-w-3xl mx-auto px-6 relative z-10">

                {/* HEADER */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                    className="mb-14"
                >

                    <p className="
            uppercase tracking-[0.3em]
            text-cyan-400 text-xs
          ">
                        Contact
                    </p>

                    <h2 className="
            text-4xl md:text-5xl
            font-bold mt-4
          ">
                        Let’s Work Together
                    </h2>

                    <p className="
            text-zinc-400 mt-6
            max-w-xl leading-relaxed
          ">
                        Have a project idea, freelance opportunity,
                        or collaboration in mind? Send me a message.
                    </p>
                </motion.div>

                {/* SUCCESS CARD */}
                <AnimatePresence>
                    {success && (
                        <motion.div
                            initial={{ opacity: 0, y: 20, scale: 0.95 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            exit={{ opacity: 0, y: -20 }}
                            className="
                mb-8 p-6 rounded-3xl
                border border-cyan-500/30
                bg-cyan-500/10
                backdrop-blur-xl
                shadow-[0_0_40px_rgba(34,211,238,0.12)]
              "
                        >

                            <h3 className="
                text-cyan-300 font-semibold text-lg
              ">
                                Message Sent Successfully
                            </h3>

                            <p className="text-zinc-300 mt-2">
                                Thanks for reaching out — I’ll get back
                                to you as soon as possible.
                            </p>

                        </motion.div>
                    )}
                </AnimatePresence>

                {/* FORM */}
                <motion.form
                    ref={form}
                    onSubmit={sendEmail}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="
            space-y-6
            p-8 rounded-[2rem]
            border border-white/10
            bg-white/5
            backdrop-blur-2xl
          "
                >

                    {/* NAME */}
                    <input
                        type="text"
                        name="name"
                        placeholder="Your name"
                        required
                        className="
              w-full p-4 rounded-2xl
              bg-black/30
              border border-white/10
              text-white

              focus:outline-none
              focus:border-cyan-500/50
              focus:shadow-[0_0_25px_rgba(34,211,238,0.15)]

              transition-all duration-300
            "
                    />

                    {/* EMAIL */}
                    <input
                        type="email"
                        name="email"
                        placeholder="Your email"
                        required
                        className="
              w-full p-4 rounded-2xl
              bg-black/30
              border border-white/10
              text-white

              focus:outline-none
              focus:border-cyan-500/50
              focus:shadow-[0_0_25px_rgba(34,211,238,0.15)]

              transition-all duration-300
            "
                    />

                    {/* MESSAGE */}
                    <textarea
                        name="message"
                        rows="6"
                        placeholder="Tell me about your project..."
                        required
                        className="
              w-full p-4 rounded-2xl
              bg-black/30
              border border-white/10
              text-white resize-none

              focus:outline-none
              focus:border-cyan-500/50
              focus:shadow-[0_0_25px_rgba(34,211,238,0.15)]

              transition-all duration-300
            "
                    />

                    {/* BUTTON */}
                    <motion.button
                        whileHover={{
                            y: -4,
                            scale: 1.02,
                        }}
                        whileTap={{
                            scale: 0.98,
                        }}
                        type="submit"
                        disabled={sending}
                        className="
              relative overflow-hidden
              px-8 py-4 rounded-2xl

              bg-cyan-500/15
              border border-cyan-500/30
              text-cyan-300

              hover:bg-cyan-500/20
              hover:shadow-[0_0_40px_rgba(34,211,238,0.2)]

              transition-all duration-300
            "
                    >

                        {/* BUTTON GLOW */}
                        <div className="
              absolute inset-0
              bg-gradient-to-r
              from-cyan-500/0
              via-cyan-400/10
              to-purple-500/0

              opacity-0 hover:opacity-100
              transition-opacity duration-500
            " />

                        <span className="relative z-10 flex items-center gap-3">

                            {sending && (
                                <span className="
                  w-4 h-4 rounded-full
                  border-2 border-cyan-300
                  border-t-transparent
                  animate-spin
                " />
                            )}

                            {sending
                                ? "Sending..."
                                : "Send Message"}

                        </span>
                    </motion.button>

                </motion.form>
            </div>
        </section>
    );
}